import { render } from "./StockProductList.vue?vue&type=template&id=8ac6a8f8&scoped=true"
import script from "./StockProductList.vue?vue&type=script&lang=js"
export * from "./StockProductList.vue?vue&type=script&lang=js"

import "./StockProductList.vue?vue&type=style&index=0&id=8ac6a8f8&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ac6a8f8"]])

export default __exports__